import { State } from 'interfaces/state'
import { connect } from 'react-redux'
import Logo, { LogoStateProps, LogoOwnProps } from 'components/features/pfm/Logo/Logo'
import { HOMEPAGE_URL, DASHBOARD_URL, COACH_URL } from 'tangle-shared'
import { isInternalUrl, isInternalOnboardingStepUrl } from 'helpers/pageHelpers'
import { memberInfoSelector, currentUrlSelector } from 'selectors/globalSelectors'
import { withRouter, RouteComponentProps } from 'react-router-dom'

type LogoContainerInnerProps = RouteComponentProps<{}>

const mapStateToProps = (state: State, ownProps: LogoContainerInnerProps): LogoStateProps => {
  const currentUrl = currentUrlSelector(state, ownProps)
  const member = memberInfoSelector(state)
  const isBlocked = member && member.is_blocked
  const isInternalNotOnboarding = isInternalUrl(currentUrl) && !isInternalOnboardingStepUrl(currentUrl)
  const toHomepage = isBlocked || !isInternalNotOnboarding || currentUrl === COACH_URL
  const targetUrl = toHomepage ? HOMEPAGE_URL : DASHBOARD_URL
  const target = toHomepage ? 'home' : 'dashboard'

  return {
    shouldScrollToTop: currentUrl === targetUrl,
    target,
  }
}

const LogoContainerInner = connect<LogoStateProps, {}, LogoOwnProps & LogoContainerInnerProps>(mapStateToProps)(Logo)
const LogoContainer = withRouter(LogoContainerInner)

export default LogoContainer
